export const PLAN_STATUS_LABELS = {
  draft: "Draft",
  awaiting_review: "Awaiting Review",
  approved: "Approved",
  returned_for_amendment: "Returned for Amendment",
  superseded: "Superseded",
  archived: "Archived",
};

export const PLAN_STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-600 border-transparent",
  awaiting_review: "bg-indigo-100 text-indigo-800 border-transparent",
  approved: "bg-ukgreen-light text-ukgreen border-transparent",
  returned_for_amendment: "bg-orange-100 text-orange-800 border-transparent",
  superseded: "bg-slate-100 text-slate-500 border-transparent",
  archived: "bg-slate-100 text-slate-500 border-transparent",
};

export const SEGMENT_TYPES = [
  { value: "walk", label: "Walk" },
  { value: "bus", label: "Bus" },
  { value: "train", label: "Train" },
  { value: "underground", label: "London Underground" },
  { value: "tram", label: "Tram" },
  { value: "transfer", label: "Transfer / Interchange" },
  { value: "other", label: "Other" },
];

export const CROSSING_TYPES = [
  { value: "pedestrian_signal", label: "Pedestrian signal crossing" },
  { value: "zebra", label: "Zebra crossing" },
  { value: "pelican_puffin", label: "Pelican/puffin or equivalent" },
  { value: "island", label: "Island" },
  { value: "uncontrolled_road", label: "Uncontrolled road" },
  { value: "side_road", label: "Side road" },
  { value: "driveway", label: "Driveway" },
  { value: "other", label: "Other" },
];

export const LANDMARK_TYPES = [
  "Shop", "Library", "Station", "Bus stop", "School gate", "Traffic lights",
  "Recognisable building", "Park", "Crossing", "Other",
];

export const RISK_CATEGORIES = [
  "road_traffic", "road_crossing", "getting_lost", "wrong_bus_train", "missing_stop",
  "transport_delay", "transport_cancellation", "route_diversion", "stranger_safety",
  "bullying_harassment", "theft_loss", "communication", "behaviour_safety",
  "sensory_environmental", "mobility_access", "health_emergency", "travel_card_failure",
  "mobile_phone_failure", "weather", "crowded_transport", "station_platform",
  "escalator_stairs", "personal_safety", "other",
];

export const LIKELIHOOD_SCALE = [
  { value: 1, label: "1 — Rare" }, { value: 2, label: "2 — Unlikely" },
  { value: 3, label: "3 — Possible" }, { value: 4, label: "4 — Likely" },
  { value: 5, label: "5 — Very likely" },
];

export const SEVERITY_SCALE = [
  { value: 1, label: "1 — Minor" }, { value: 2, label: "2 — Moderate" },
  { value: 3, label: "3 — Significant" }, { value: 4, label: "4 — Major" },
  { value: 5, label: "5 — Severe" },
];

export const CONTROL_EXAMPLES = [
  "Repeated road-crossing practice", "Use of controlled crossing", "Visual route prompts",
  "Trainer shadowing", "Alternative bus stop", "Additional familiarisation",
  "Agreed emergency contact", "Alternative route", "Travel at quieter times during early training",
  "Communication aid", "Additional journey rehearsal",
];

export const EMERGENCY_SITUATIONS = [
  { key: "child_lost", label: "Child is lost" },
  { key: "wrong_bus_train", label: "Wrong bus/train" },
  { key: "missed_stop", label: "Missed stop" },
  { key: "transport_cancelled", label: "Transport cancelled" },
  { key: "route_diverted", label: "Route diverted" },
  { key: "travel_card_not_working", label: "Travel card does not work" },
  { key: "travel_card_lost", label: "Travel card lost" },
  { key: "phone_lost", label: "Mobile phone lost" },
  { key: "phone_battery_dead", label: "Mobile phone battery dead" },
  { key: "child_feels_unsafe", label: "Child feels unsafe" },
  { key: "being_followed_harassed", label: "Being followed/harassed" },
  { key: "child_unwell", label: "Child becomes unwell" },
  { key: "accident_injury", label: "Accident/injury" },
  { key: "major_disruption", label: "Major transport disruption" },
];

export const ROUTE_CHANGE_REASONS = [
  { value: "bus_route_changed", label: "Bus route changed" },
  { value: "bus_stop_moved", label: "Bus stop moved" },
  { value: "road_closure", label: "Road closure" },
  { value: "school_entrance_changed", label: "School entrance changed" },
  { value: "transport_service_changed", label: "Transport service changed" },
  { value: "new_hazard", label: "New hazard" },
  { value: "construction", label: "Construction" },
  { value: "safety_concern", label: "Safety concern" },
  { value: "child_circumstances_changed", label: "Child circumstances changed" },
  { value: "other", label: "Other" },
];

export const BAND_STYLES = {
  low: "bg-ukgreen-light text-ukgreen border-transparent",
  medium: "bg-amber-100 text-amber-800 border-transparent",
  high: "bg-red-50 text-red-700 border-transparent",
};
